import React from 'react';
import { contactData } from '../mock';
import { Card, CardContent } from './ui/card';
import { Mail, Phone, MapPin } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contacto" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#0A3A48] mb-4">Contacto</h2>
          <div className="w-24 h-1 bg-[#5E8B7E] mx-auto mb-6"></div>
          <p className="text-xl text-[#4A4A4A] max-w-3xl mx-auto">
            Contáctanos para conocer cómo podemos ayudarte con tu proyecto
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Information */}
          <div>
            <h3 className="text-2xl font-bold text-[#0A3A48] mb-6">Información de Contacto</h3>
            
            <div className="space-y-6">
              <Card className="border-0 shadow-md hover:shadow-lg transition-shadow">
                <CardContent className="p-6 flex items-start">
                  <div className="p-3 bg-[#5E8B7E]/10 rounded-lg mr-4">
                    <MapPin className="text-[#5E8B7E]" size={24} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#0A3A48] mb-1">Dirección</h4>
                    <p className="text-[#4A4A4A]">{contactData.address}</p>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-0 shadow-md hover:shadow-lg transition-shadow">
                <CardContent className="p-6 flex items-start">
                  <div className="p-3 bg-[#5E8B7E]/10 rounded-lg mr-4">
                    <Phone className="text-[#5E8B7E]" size={24} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#0A3A48] mb-1">Teléfono</h4>
                    <a 
                      href={`tel:${contactData.phone.replace(/\s/g, '')}`}
                      className="text-[#4A4A4A] hover:text-[#5E8B7E] transition-colors"
                    >
                      {contactData.phone}
                    </a>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-0 shadow-md hover:shadow-lg transition-shadow">
                <CardContent className="p-6 flex items-start">
                  <div className="p-3 bg-[#5E8B7E]/10 rounded-lg mr-4">
                    <Mail className="text-[#5E8B7E]" size={24} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#0A3A48] mb-1">Email</h4>
                    <a 
                      href={`mailto:${contactData.email}`}
                      className="text-[#4A4A4A] hover:text-[#5E8B7E] transition-colors"
                    >
                      {contactData.email}
                    </a>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* Map */}
          <div>
            <h3 className="text-2xl font-bold text-[#0A3A48] mb-6">Ubicación</h3>
            <div className="rounded-lg overflow-hidden shadow-xl h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3068.7489!2d-73.24589!3d-39.81403!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9615f1a1e1e1e1e1%3A0x1e1e1e1e1e1e1e1e!2sCarlos%20Anwandter%20630%2C%20Valdivia!5e0!3m2!1ses!2scl!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación EDIFÍSICA"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
